import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ContextMenu from '../ContextMenu';
import DrawButton from '../DrawButton';
import { DECK } from '../ActiveGame/contextMenuTypes';
import { selectDeckPile, selectPlayer } from '../ActiveGame/selectors';
import { Stat } from '../ContextMenu/styled';

const DeckContextMenu = ({ userId }) => {
  const deckPile = useSelector((state) => selectDeckPile(state, { userId }));
  const player = useSelector(selectPlayer);

  if (!deckPile) {
    return null;
  }

  const mine = userId === player.getIn(['user', 'id']);

  return (
    <ContextMenu menu={DECK} userId={userId} title={mine ? 'Your deck' : "Opponent's deck"}>
      <Stat><b>{deckPile.get('count')}</b> cards left</Stat>
      <div style={{ marginTop: 12 }}><DrawButton userId={userId} /></div>
    </ContextMenu>
  );
};

DeckContextMenu.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default DeckContextMenu;
